import { Tooltip } from "react-tooltip";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useContext, useEffect, useState } from "react";
import { FormContext } from "../../../context/FormContext";

function ContentForm() {
  const { formData, updateForm } = useContext(FormContext);

  const IMPRESSIONS_PER_FOLLOWER = 3;  
  const AVERAGE_ACCOUNT_MONTHS = 48;   
  const RPM = 19.80;                    

  const [local, setLocal] = useState({
    followerCount: formData.followerCount?.toString() ?? "",
  });

  useEffect(() => {
    const ctxVal = Number(formData?.followerCount ?? 0);
    // only update if different to avoid cursor jumps while typing
    if (!Number.isNaN(ctxVal) && ctxVal !== local.followerCount) {
      setLocal(p => ({ ...p, followerCount: ctxVal }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.followerCount]);

  // --- derived values ---
  const count = Number(local.followerCount) || 0;
  const impressions = Math.floor(count * IMPRESSIONS_PER_FOLLOWER * AVERAGE_ACCOUNT_MONTHS);
  const revenue = (impressions / 1000) * RPM;

  return (
    <>
      <div className="contents-main">
        <h1>Meta makes money every time you post.</h1>
        <div>
          <p>
            Meta earns on average <b>$19.80 for every 1,000 impressions.</b>
          </p>
          <p>
            Here's how much your posts made:
          </p>

          <div className="" style={{ marginTop: 25 }}>
            <span style={{fontSize: 18}}>( <b>{local.followerCount*3*48}</b> ÷ 1000 ) x $19.80</span>
          </div>
          <p style={{fontSize: 13, color: 'grey', marginBottom: 0, marginTop: 5}}>
            {local.followerCount*3*48} is your estimated impressions over four years, the average age of an Instagram account.
          </p>

        </div>
      </div>

      <div className="contents-footer">
        <p className="footer-label">Your Content Revenue</p>
        <p className="footer-value">${revenue.toFixed(2)}</p>
      </div>

    </>
  );
}
export default ContentForm;
